import React, { Component } from "react";
import { Container, Row, Col, Media, UncontrolledTooltip } from "reactstrap";
import { Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import KanbanBoard from "./KanbanBoard";

//Import Logo
import logosmlight from "../../assets/images/logo-sm-light.png";
import logosmdark from "../../assets/images/logo-sm-dark.png";
import avatar2 from "../../assets/images/users/avatar-2.jpg";
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import avatar4 from "../../assets/images/users/avatar-4.jpg";
import avatar5 from "../../assets/images/users/avatar-5.jpg";
import avatar6 from "../../assets/images/users/avatar-6.jpg";
import avatar7 from "../../assets/images/users/avatar-7.jpg";
import avatar8 from "../../assets/images/users/avatar-8.jpg";

//Import scss
import "./kanban-style.scss";

class IndexKanban extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        {
          id: 1,
          title: "Facility Management",
          columnsubtitle: "3 Active",
          cards: [
            {
              id: 11,
              content: {
                id: "#NZ1220",
                title: "Company 1",
                subtitle: "10 Chargers",
                date: "14 Oct, 2024",
                progressValue: 75,
                team: [
                  { id: 1, name: "joseph", img: avatar2 },
                  { id: 2, name: "joseph", img: avatar4 },
                ],
              },
            },
            {
              id: 12,
              content: {
                id: "#NZ1219",
                title: "Company 3",
                subtitle: "18 Chargers",
                date: " 15 Nov, 2024",
                progressValue: 50,
                team: [{ id: 3, name: "Misty", img: "Null" }],
              },
            },
            {
              id: 13,
              content: {
                id: "#NZ1218",
                title: "Company 2",
                subtitle: "24 Chargers",
                date: "13 May, 2024",
                progressValue: 65,
                team: [
                  { id: 4, name: "joseph", img: avatar5 },
                  { id: 5, name: "Jenice Bliss", img: "Null" },
                  { id: 6, name: "John", img: avatar6 },
                ],
              },
            },
          ],
        },
        {
          id: 2,
          title: "RWA",
          columnsubtitle: "2 Active",
          cards: [
            {
              id: 21,
              content: {
                id: "#NZ1217",
                title: "Property 1",
                subtitle: "2 Chargers",
                date: "05 Apr, 2024",
                progressValue: 45,
                team: [
                  { id: 7, name: "joseph", img: avatar7 },
                  { id: 8, name: "Edward", img: "Null" },
                  { id: 9, name: "John", img: avatar8 },
                ],
              },
            },
            {
              id: 22,
              content: {
                id: "#NZ1216",
                title: "Property 2",
                subtitle: "6 Chargers",
                date: "02 Apr, 2024",
                progressValue: 80,
                team: [
                  { id: 10, name: "joseph", img: avatar7 },
                  { id: 11, name: "John", img: avatar2 },
                ],
              },
            },
            {
              id: 23,
              content: {
                id: "#NZ1215",
                title: "Property 3",
                subtitle: "2 Chargers",
                date: "28 Mar, 2024",
                progressValue: 0,
                team: [{ id: 12, name: "Amver", img: avatar4 }],
              },
            },
          ],
        },
        {
          id: 3,
          title: "Others",
          columnsubtitle: "1 Active",
          cards: [
            {
              id: 31,
              content: {
                id: "#NZ1214",
                title: "iPec India Pvt Ltd",
                subtitle: "3 Chargers",
                date: "24 Mar, 2024",
                progressValue: 80,
                team: [{ id: 13, name: "Karen", img: "Null" }],
              },
            },
            {
              id: 32,
              content: {
                id: "#NZ1218",
                title: "iqlabs.io",
                subtitle: "1 Charger",
                date: "20 Mar, 2024",
                progressValue: 77,
                team: [
                  { id: 15, name: "Anvith", img: "Null" },
                  { id: 16, name: "Adarsha", img: "Null" },
                ],
              },
            },
          ],
        },
      ],
    };
  }
  render() {
    const breadcrumbItems = [
      { title: "SmartComm", link: "#" },
      { title: "Customers", link: "#" },
    ];
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Customers" breadcrumbItems={breadcrumbItems} />

            <Row className="mb-2">
              <Col lg={6}>
                <Media>
                  <div className="mr-3">
                    <img src={logosmdark} alt="" className="avatar-xs" />
                  </div>
                  <Media body>
                    <h5>SmartComm admin Dashboard</h5>
                    <span className="btn badge-soft-primary">
                      <li className="list-inline-item">
                        <Link to="cms-add-customer" className="py-3">
                          <i className="mdi mdi-plus mr-1"></i> New Customer
                        </Link>
                      </li>
                    </span>
                  </Media>
                </Media>
              </Col>
              <Col lg={6}>
                <div className="text-lg-right">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <Link to="#" className="d-inline-block" id="member1">
                        <div className="avatar-xs">
                          <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                            R
                          </span>
                        </div>
                      </Link>
                      <UncontrolledTooltip target="member1" placement="top">
                        Raju Pillai
                      </UncontrolledTooltip>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#" className="d-inline-block" id="member2">
                        <div className="avatar-xs">
                          <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                            J
                          </span>
                        </div>
                      </Link>
                      <UncontrolledTooltip target="member2" placement="top">
                        User 1
                      </UncontrolledTooltip>
                    </li>

                    <li className="list-inline-item">
                      <Link to="#" className="py-1">
                        <i className="mdi mdi-plus mr-1"></i> New Member
                      </Link>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>

            <Row>
              <KanbanBoard board={this.state} content={this.state.columns} />
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default IndexKanban;
